module.exports = __webpack_public_path__ + "static/adjustable-bed-frame-1-5edc569f61fffcaf18db5b70f4e918b3.mp4";